import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么3000万吃瓜群众选择黑料每日大赛
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto">
          {featuresData.map((feat) => (
            <div key={feat.id} className="group p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${feat.icon} text-xl md:text-2xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}